import algoliasearch from "algoliasearch";

const client = algoliasearch("QWNFE5DQSI", "f8afb931b6d3e7b2706ca68cb2f13d8a");
export const index = client.initIndex("index");